import { useApplicationContext } from 'shared/utils/applicationContext';

export function useRuntimeSetting<T>(key: string, defaultValue: T): T;

export function useRuntimeSetting<T>(key: string): T | null;

export function useRuntimeSetting<T>(key: string, defaultValue: T | null = null): T | null {
  const { config } = useApplicationContext();

  return config.get<T>(key) ?? defaultValue;
}
